import React from "react";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import NavSubItem, { NavSubItemWithPermission } from "../Sidebar/NavSubItem";
import { IconSimulation } from "../../Icons";
import IconEmail from "../../Icons/Servicing/Tools/Email";
import IconGeneral from "../../Icons/Servicing/Tools/General";
import IconStoreRetrieve from "../../Icons/Servicing/Tools/StoreRetrieve";
import IconTesting from "../../Icons/TopCommandPanel/SetupTesting";
import { getModuleStateById } from "../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { ESuiteMode } from "../../Model/ModuleState";
import { EComponentId } from "../../Model/Permission";

export default function ToolsNavSubMenu() {
  const isTesting = useTypedSelector(
    (state) =>
      getModuleStateById(state)["Suite"].suite?.suiteMode == ESuiteMode.Testing
  );

  return (
    <SidebarSubmenu>
      <NavSubItem
        label="Store and Retrieve"
        key="store-and-retrieve"
        to="/tools/store-and-retrieve"
        icon={<IconStoreRetrieve />}
        disabled={isTesting}
      />

      <NavSubItem
        label="General"
        key="general"
        to="/tools/general"
        icon={<IconGeneral />}
        disabled={isTesting}
      />

      <NavSubItem
        label="Email"
        key="email"
        to="/tools/email"
        icon={<IconEmail />}
        disabled={isTesting}
      />

      <NavSubItem
        label="Testing"
        key="testing"
        to="/tools/testing"
        icon={<IconTesting />}
        disabled={isTesting}
      />

      <NavSubItemWithPermission
        label="Simulation"
        key="simulation"
        to="/tools/simulation"
        icon={<IconSimulation />}
        disabled={isTesting}
        componentId={EComponentId.ToolsSimulation}
      />
    </SidebarSubmenu>
  );
}
